module.exports = __webpack_public_path__ + "img/4.73ebd82f.png";